export const BETTERPLACE_SESSION_COOKIE_NAME = 'betterplace_session'
export const MIN_SEARCH_TEXT_LENGTH = 3
